export type NexPageSize = 10 | 25 | 50
export const nexPageSizes: NexPageSize[] = [10, 25, 50]
export const nexDefaultPagination: { page: number; pageSize: NexPageSize } = { pageSize: 10, page: 0 }
